let language = {

    RESET_PASSWORD_CHANGE_PASSWORD_TITLE: "修改密码",
    
    RESET_PASSWORD_FORM_PASSWORD_LABEL: "密码:",
    RESET_PASSWORD_FORM_PASSWORD_PLACEHOLDER: "请输入密码",
    RESET_PASSWORD_FORM_PASSWORD_ERROR_TIP1: "请输入8至20个字符，包括大写字母、小写字母、数字和符号",
    RESET_PASSWORD_FORM_REPEAT_PASSWORD_LABEL: "确认密码:",
    RESET_PASSWORD_FORM_REPEAT_PASSWORD_PLACEHOLDER: "请检查密码",
    RESET_PASSWORD_FORM_REPEAT_PASSWORD_ERROR_TIP1: "您的“确认密码”应该与您的密码相同",
    RESET_PASSWORD_FORM_SUBMIT_BTN: "修改密码",
};

export { language }